<ng-container *ngIf="filterOptions.length; else noSupportedOperators">
  <div fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="center center">
    <mat-form-field fxFlex appearance="outline">
      <mat-label i18n>Operation</mat-label>
      <mat-select [(ngModel)]="newValue.operation">
        <mat-option *ngFor="let option of filterOptions" [value]="option" [disabled]="!enabledOptions[option.type]">{{
          option?.label
        }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field fxFlex appearance="outline">
      <mat-label i18n>Value</mat-label>
      <input matInput i18n-placeholder placeholder="Value" [(ngModel)]="newValue.value" type="number" />
    </mat-form-field>

    <button
      mat-mini-fab
      class="add-filter-button"
      color="accent"
      [disabled]="!newValue.operation || newValue.value === null || newValue.value === undefined"
      (click)="handleAdd(newValue)"
    >
      <mat-icon>add</mat-icon>
    </button>
  </div>

  <rds-c-chips
    [chips]="filters | rdsFiltersToChips"
    [dense]="false"
    [removable]="true"
    (removed)="handleRemove($event)"
    [vertical]="true"
  ></rds-c-chips>
</ng-container>
<ng-template #noSupportedOperators>
  <p i18n>No filter operations are supported for this data product.</p>
</ng-template>
